import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateOrDeleteButton',
  props: {
    isAdded: { type: Boolean, default: true },
    btnName: {},
    btnStyle: {},
    btnColor: { default: '' },
    actionKey: { default: '' }
  },
  emits: ['addRequested'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit

const props = __props

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(_component_v_btn, {
    class: "ma-2 exec-btn",
    disabled: !props.isAdded,
    color: props.btnColor,
    style: _normalizeStyle({ backgroundColor: props.isAdded ? '' : props.btnStyle, }),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('addRequested', props.actionKey)))
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(props.btnName), 1)
    ]),
    _: 1
  }, 8, ["disabled", "color", "style"]))
}
}

})